<style lang="stylus" scoped>
.noticewrap
  position relative
  height:100%
  display:flex
  align-items:center
  .noticepopupwrap
    display none
    // display block
    position absolute
    z-index 4
    top: 80px
    right: 0
    padding 0 20px
    width: 488px
    height:494px
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 30px 0px rgba(0,0,0,0.17);
    border-radius:10px;
    color: #717171
    text-align: left
    font-size: 12px
    .extend_popup
      position absolute
      right 0px
      top -40px
      height 40px
      width 150px
      background transparent
    .notice-tag
      display:flex
      justify-content:space-around
      height:77px
      font-size:16px;
      cursor: pointer;
      .notice-tga1
        height:73px;
        font-size:16px;
        font-weight:500;
        color:rgba(68,68,68,1);
        line-height:73px;
        border-bottom:4px solid #2751CB;
      .notice-tga2
        height:73px;
        line-height:73px;
    .noticepopuptitle
      height: 40px
      line-height: 40px
      cursor default
      border-bottom: 1px solid #c2d2dc
      font-size 14px
      color #90a8b7
    .read_more
      height 77px
      line-height 77px
      text-align center
      font-size:16px;
      font-weight:400;
      color:rgba(39,81,203,1);
      a
        color: #787878
        font-size: 14px
    ul
      line-height: 0
      cursor: default
      padding:0 30px
      max-height: 340px
      overflow-y: auto
      li
        box-sizing: border-box
        line-height: 0
        height:85px;
        border-bottom: 1px solid #f5f8f9
        display:flex;
        align-items:center;
        // &:last-child
          // border:none
        .img
          position: relative
          float: left
          width:45px;
          height:45px;
        .noti_content
          margin: 0px 0 0 10px
          line-height: 14px
          word-break: break-word
          word-wrap: break-word
          a
            // color: #717171
          .content_link
            color: active
          .text
            word-break: break-word
            word-wrap: break-word
            line-height 20px
            a
              line-height: 18px
  &:hover
    .noticepopupwrap
      display block
  a:hover
    color: #0050b3 !important
</style>
<style lang="stylus">
  .notice-tga2
    .el-badge__content.is-fixed
      top:20px !important;
      right:5px !important;
</style>

<template>
  <div class="noticewrap" @mouseenter="enterNews" @mouseleave="readAll"><!-- @mouseleave="readAll" 先去掉全部读取消息 -->
    <el-badge :value="unReadNum + consultReadNum + chatUnreadNum" :max="99" :hidden="!(unReadNum + consultReadNum + chatUnreadNum)"  style="display:flex;align-items:center;">
      <slot></slot>
    </el-badge>
    <div class="noticepopupwrap">
      <!-- <div class="noticepopuptitle">{{unReadNum}} 条未读消息</div> -->
      <div class="notice-tag">
        <div class="notice-tga1">通知</div>
        <div class="notice-tga2" @click="gotoHonsenChat"><el-badge :value="consultReadNum" :max="99" :hidden="!consultReadNum">咨询</el-badge></div>
        <div class="notice-tga2" @click="gotoChat"><el-badge :value="chatUnreadNum" :max="99" :hidden="!chatUnreadNum">私信</el-badge></div>
      </div>
      <ul v-if="recentNotifs.length" v-scrollUnique>
        <li class="clearfix" v-for="notif in recentNotifs">
          <div class="img">
              <el-badge 
                v-if="notif.type == nType.company_normal || notif.type == nType.company_normal_del || notif.type == nType.choose_lawyer || notif.type == nType.replaced_lawyer || notif.type == nType.renew_choose_lawyer || notif.type === nType.company_account_dredge|| notif.type === nType.company_account_remove||notif.type === nType.add_serve_lawyer||notif.type === nType.del_serve_lawyer||notif.type === nType.latent_com_change||!notif.detail.f" 
                :is-dot="!notif.is_readed">
                <img src="/static/img/logo2.png" width="38px" style="border-radius: 50%;">
              </el-badge>
              <el-badge v-else :is-dot="!notif.is_readed">
                <span @click="toPersonalCenter(notif.detail.f)" style="cursor: pointer">
                  <img :src="$avatarHash(notif.detail.f)" style="border-radius: 50%;width:45px;height:45px;">
                </span>
              </el-badge>
          </div>

          <!--消息类型-->
          <div class="noti_content">
            <a v-if="notif.type == nType.company_normal || notif.type == nType.company_normal_del || notif.type == nType.choose_lawyer || notif.type == nType.replaced_lawyer || notif.type == nType.renew_choose_lawyer || notif.type === nType.company_account_dredge|| notif.type === nType.company_account_remove||notif.type === nType.add_serve_lawyer||notif.type === nType.del_serve_lawyer||notif.type === nType.latent_com_change">{{notif.detail.f_n}}&nbsp;&nbsp;</a>
            <a v-else-if="notif.detail.f_n" href="javascript:;" @click="toPersonalCenter(notif.detail.f)">{{notif.detail.f_n}}&nbsp;&nbsp;</a>
            <!--消息类型-->
            <span class="text" v-if="notif.type === nType.auth_edit">授予你在<a class="content_link" href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》{{notif.detail.num > 1 ? '等多篇知识' : ''}}</a>中的编辑权限</span>

            <span class="text" v-if="notif.type === nType.auth_view">授予你在<a class="content_link" href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》{{notif.detail.num > 1 ? '等多篇知识' : ''}}</a>中的阅读权限</span>

            <span class="text" v-if="notif.type === nType.user_follow">关注了你</span>

            <span class="text" v-if="notif.type === nType.post_comment">评论了你的知识<a class="content_link" href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》</a></span>

            <span class="text" v-if="notif.type === nType.comment_comment">回复了你在<a class="content_link" href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》</a>中的评论</span>

            <span class="text" v-if="notif.type === nType.post_upvote">点赞了你的知识<a class="content_link" href="javascript:;" @click="toPostDetail(notif.detail.a)">《{{notif.detail.a_n}}》</a></span>

            <span class="text" v-if="notif.type === nType.keep_comment">回复了你的案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}} &gt; 案件进展</span>

            <span class="text" v-if="notif.type === nType.case_create">创建了团队案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a)">《{{notif.detail.a_n}}》</a></span>

            <span class="text" v-if="notif.type === nType.keep_add">在你的案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}} 中新增了案件进展</span>

            <span class="text" v-if="notif.type === nType.keep_update">在你的案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}} &gt; 案件进展 中更新了附件</span>

            <span class="text" v-if="notif.type === nType.flow_comment">评论了你的案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n.case}}》</a>：{{notif.detail.a_n.flow || '未命名流程'}}</span>

            <span class="text" v-if="isLawyer && notif.type === nType.case_comment">回复了你对业务《{{notif.detail.a_n.case}}》
            <!-- <a class="content_link" href="javascript:;" @click="toBusinessList(notif.detail.a)">《{{notif.detail.a_n.case}}》</a> -->
            的评论</span>

            <span class="text" v-if="!isLawyer && notif.type === nType.case_comment">回复了你发布的业务《{{notif.detail.a_n.case}}》
            <!-- <a class="content_link" href="javascript:;" @click="toSelectLawyer(notif.detail.a)">《{{notif.detail.a_n.case}}》</a> -->
            </span>

            <span class="text" v-if="notif.type === nType.coactor">授予你成为案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n}}》</a>的协作者</span>

            <span class="text" v-if="notif.type === nType.visitor">授予你案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n}}》</a>的查看权限</span>

            <span class="text" v-if="notif.type === nType.contact">授予你成为案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n}}》</a>的联系人</span>

            <span class="text" v-if="notif.type === nType.lawyer_designate">选择你成为案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n}}》</a>的办理律师</span>

            <span class="text" v-if="notif.type === nType.join_team">已将你添加为团队成员</span>

            <!-- 审核的消息 -->
            <span class="text" v-if="notif.type === nType.admin_auth && notif.detail.result">{{notif.detail.reason}}</span>
            <span class="text" v-if="notif.type === nType.admin_auth && !notif.detail.result">{{notif.detail.reason}}。请重新去 <a class="content_link" href="javascript:;" @click="toConfirm">认证</a> ！</span>

            <span class="text" v-if="notif.type === nType.enterprise_audit && notif.detail.result">{{notif.detail.reason}}</span>
            <span class="text" v-if="notif.type === nType.enterprise_audit && !notif.detail.result">{{notif.detail.reason}}</span>

            <span class="text" v-if="notif.type === nType.order_audit && notif.detail.result">{{notif.detail.reason}}</span>
            <span class="text" v-if="notif.type === nType.order_audit && !notif.detail.result">{{notif.detail.reason}}</span>

            <span class="text" v-if="notif.type === nType.enterprise_audit_change && notif.detail.result">{{notif.detail.reason}}</span>
            <span class="text" v-if="notif.type === nType.enterprise_audit_change && !notif.detail.result">{{notif.detail.reason}}</span>

            <span class="text" v-if="notif.type === nType.enterprise_audit_change_admin && notif.detail.result">{{notif.detail.reason}}</span>
            <span class="text" v-if="notif.type === nType.enterprise_audit_change_admin && !notif.detail.result">{{notif.detail.reason}}</span>

            <!-- 日程添加 -->
            <span class="text" v-if="notif.type === nType.schedure_add">将你添加为日程<a class="content_link" href="javascript:;" @click="$store.commit('showSchPanel')">《{{notif.detail.a_n}}》</a>的成员，日程的开始时间为{{notif.detail.s_t | getDate}}</span>

            <span class="text" v-if="notif.type === nType.expire_remind">您的账号 {{notif.detail.a_n}}，请及时<a href="javascript:;" @click="gotoOrderMange" class="content_link">续费</a></span>

            <span class="text" v-if="notif.type === nType.user_evaluate">{{notif.detail.f_n ? '' : '匿名用户 '}}评价了您，可去<a href="javascript:;" @click="toPersonalCenter($store.state.mineInfo.id)" class="content_link"> 个人中心 </a>进行查看</span>

            <!-- 案件流程跟进@ -->
            <span class="text" v-if="notif.type === nType.flow_caseRecord">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.c_id, notif.detail.f_id)">《{{notif.detail.c_name}}》</a>的流程《{{notif.detail.f_name || '未命名流程'}}》的跟进：{{notif.detail.a_n}} 中@了你</span>

            <!-- 流程推送 -->
            <span class="text" v-if="notif.type === nType.flow_push">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)">《{{notif.detail.a_n.case}}》</a>中给你推送了流程 {{notif.detail.a_n.flow || '未命名流程'}}</span>

            <!-- 流程授权 -->
            <span class="text" v-if="notif.type === nType.flow_auth_edit">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.flow_id)">《{{notif.detail.a_n.case}}》</a>中给你授权了流程 {{notif.detail.a_n.flow || '未命名流程'}} 的编辑权限</span>

            <!-- 推送附件通知 -->
            <span class="text" v-if="notif.type === nType.file_push">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)">《{{notif.detail.a_n.case}}》</a>中的流程 {{notif.detail.a_n.flow || '未命名流程'}} 给你推送了附件 {{notif.detail.a_n.file}}</span>

            <span class="text" v-if="notif.type === nType.dissolve_team">解散了团队</span>
            <span class="text" v-if="notif.type === nType.quit_team">退出了团队</span>
            <span class="text" v-if="notif.type === nType.kickout_team">把你移出了团队</span>

            <span class="text" v-if="notif.type === nType.client_coactor">将您添加为案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_f)">《{{notif.detail.a_n}}》</a>的协作者</span>

            <!-- 2018.7.27 新增通知 -->
            <span class="text" v-if="notif.type === nType.company_admin">您成为 {{notif.detail.a_n}} 
            <!-- <a class="content_link" href="javascript:;" @click="toCompany"> {{notif.detail.a_n}} </a> -->
            公司的管理员</span>

            <span class="text" v-if="notif.type === nType.normal_create_case">添加了案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)"> 《{{notif.detail.a_n}}》 </a></span>

            <span class="text" v-if="notif.type === nType.lawyer_create_company_case">律师给您创建了新的案件</span>

            <span class="text" v-if="notif.type === nType.normal_del_case">删除了案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)"> 《{{notif.detail.a_n}}》 </a>，删除的案件将存到您的最近删除列表</span>

            <span class="text" v-if="notif.type === nType.normal_create_flow">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a, notif.detail.a_n.flow_id)"> 《{{notif.detail.a_n.case}}》 </a>中新增了流程</span>

            <span class="text" v-if="notif.type === nType.normal_del_flow">在案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a)"> 《{{notif.detail.a_n.case}}》 </a>中删除了流程 {{notif.detail.a_n.flow || '未命名流程'}}</span>

            <span class="text" v-if="notif.type === nType.service_expire">请到已购服务列表查看</span>

            <span class="text" v-if="notif.type === nType.service_affirm">律师向您发起了 {{notif.detail.a_n}} 
            <!-- <a class="content_link" href="javascript:;" @click="toCompanyService"> {{notif.detail.a_n}} </a> -->
            确认完成请求，请到对应的服务项下面处理</span>

            <span class="text" v-if="notif.type === nType.choose_lawyer">选择您为该公司的法律顾问</span>

            <span class="text" v-if="notif.type === nType.replaced_lawyer">解除了与您的合作关系，请双方遵守《服务协议》</span>

            <span class="text" v-if="notif.type === nType.renew_choose_lawyer">选择您为该公司的法律顾问，开始服务时间为：{{notif.detail.r_t}}</span>

            <span class="text" v-if="notif.type === nType.company_create_case">给您发布了新的案件<a class="content_link" href="javascript:;" @click="toCaseEdit(notif.detail.a)"> 《{{notif.detail.a_n}}》 </a></span>

            <span class="text" v-if="notif.type === nType.refuse_service_affirm">您发起的 {{notif.detail.a_n}} 确认服务请求被拒绝，请与客户沟通；</span>

            <span class="text" v-if="notif.type === nType.agree_service_affirm">您发起的 {{notif.detail.a_n}} 确认服务请求已确认完成</span>

            <span class="text" v-if="notif.type === nType.company_normal">添加您为该公司的法务人员</span>

            <span class="text" v-if="notif.type === nType.company_normal_del">将您请离该公司的企业服务号</span>


            <!-- 2018.12.26新增消息通知 -->
            <span class="text" v-if="notif.type === nType.latent_com_push">给您推送了新客户<a class="content_link" href="javascript:;" @click="customerDetails(1,notif)"> {{notif.detail.a_n}} </a></span>
            <!-- 未测试 -->
            <span class="text" v-if="notif.type === nType.latent_com_change">取消了您与客户<a  class="content_link" href="javascript:;">{{notif.detail.a_n}}</a>的合作关系</span>

            <span class="text" v-if="notif.type === nType.add_honsen_role" >将您添加为弘商的{{notif.detail.r }}</span>

            <span class="text" v-if="notif.type === nType.del_honsen_role">取消您的{{notif.detail.r }}身份</span>
            
            <!-- 这个接口要跳转到 /admin/list 客户详情 -->
            
            <span class="text" v-if="notif.type === nType.add_company_salesman">授予您对企业客户 《{{notif.detail.a_n}}》 
            <!-- <a class="content_link" href="javascript:;" @click="goAdminList(notif.detail.a)">《{{notif.detail.a_n}}》 </a> -->
            编辑权限</span>

            <span class="text" v-if="notif.type === nType.del_company_salesman">取消您对客户 《{{notif.detail.a_n}}》 编辑权限</span>

            <span class="text" v-if="notif.type === nType.add_serve_lawyer">：恭喜您成为弘商的合作企业服务律师</span>

            <span class="text" v-if="notif.type === nType.del_serve_lawyer">：您已不是弘商的合作企业律师了</span>

            <span class="text" v-if="notif.type === nType.company_account_dredge">为您开通了企业服务号</span>
            
            <span class="text" v-if="notif.type === nType.company_account_remove">将您从企业服务号中删除</span>

            <!-- 2019.02.22 -->
            <span class="text" v-if="notif.type === nType.customer_coactor">授予您为客户《{{notif.detail.a_n}}》的案件协作者</span>

            <span class="text" v-if="notif.type === nType.customer_visitor">授予您客户《{{notif.detail.a_n}}》的案件查看权限</span>

            <span class="text" v-if="notif.type === nType.add_lawyerClient_cooperation">授予您对律师客户《{{notif.detail.a_n}}》 
            <!-- <a class="content_link" href="javascript:;" @click="goAdminLawyer(notif.detail.a)">《{{notif.detail.a_n}}》 </a> -->
            编辑权限</span>
            <span class="text" v-if="notif.type === nType.del_lawyerClient_cooperation">取消您对律师客户 《{{notif.detail.a_n}}》 编辑权限</span>

            <!-- 2019.6.26，邀请律师加入咨询会话 -->
            <span class="text" v-if="notif.type === nType.invite_lawyer">您有一个咨询会话邀请 <a class="content_link" href="javascript:;" @click="toLawyerChat(notif)"> 点击进入 </a></span>

            <!-- 2020,8,31,台账劳动合同到期提示 -->
            <span class="text" v-if="notif.type === nType.standing_book"><a class="content_link" href="javascript:;" @click="goStandBook(notif.detail.a)">{{notif.detail.a_n.name}}的劳动合同要到期了</a></span>

            <!-- 2020,9,24,知识的阅读，编辑权限的取消 -->
            <span class="text" v-if="notif.type === nType.cancel_auth_editor"><span v-if="notif.detail.post_num == 1">取消了你在《{{notif.detail.a_n}}》知识的编辑权限</span><span v-else>取消了对你知识的编辑权限</span></span>
            <span class="text" v-if="notif.type === nType.cancel_auth_viewer"><span v-if="notif.detail.post_num == 1">取消了你在《{{notif.detail.a_n}}》知识的阅读权限</span><span v-else>取消了对你知识的阅读权限</span></span>

            <!-- 2020,11,11,企业客户合同到期提示 -->
            <span class="text" v-if="notif.type === nType.customers_sign_date">
              <span v-if="isCompany &&  isCompany == notif.detail.cid">您的企业法务合同
                <span v-if="notif.detail.date_diff >= 0">即将到期</span>
                <span v-else>已到期</span>
              </span>
              <!-- <span v-else><router-link :to="{name:'customerDetail', params: {ctm_id:notif.detail.ctmid}}">{{notif.detail.name}}</router-link>的企业法务合同
                <span v-if="notif.detail.date_diff >= 0">即将到期</span>
                <span v-else>已到期</span>
              </span> -->
			  <span v-else><a class="content_link" href="javascript:;" @click="customerDetails(2,notif)">{{notif.detail.name}}</a>的企业法务合同<span v-if="notif.detail.date_diff >= 0">即将到期</span><span v-else>已到期</span></span>
            </span>
            <!-- 2020.12.8.退休提示 -->
            <span class="text" v-if="notif.type === nType.employee_retire">
              <span>员工 {{notif.detail.a_n.name}}  快到法定退休年龄了</span>
            </span>
            <!-- 2021.1.8种子用户相关信息 -->
            <span class="text" v-if="notif.type === nType.set_seeds_user">
              <span>{{notif.detail.a_n}}</span>
            </span>
            <!-- 2021.3.9法律专栏付费成功 -->
            <span class="text" v-if="notif.type === nType.law_article_pay_success">
              <span v-if="notif.detail.is_author == 0">您支付的商事法律专栏知识<a class="content_link" href="javascript:;" @click="toLawArticle(notif)"> {{notif.detail.a_f}}  </a> 已付费成功！</span>
              <span v-else>已支付您的商事法律专栏<a class="content_link" href="javascript:;" @click="toLawArticle(notif)"> {{notif.detail.a_f}} </a></span>
            </span>
            <!-- 2021.3.9法律专栏付费失败 -->
            <span class="text" v-if="notif.type === nType.law_article_pay_fail">
              <span v-if="notif.detail.is_author == 0">您支付的商事法律专栏知识<a class="content_link" href="javascript:;" @click="toLawArticle(notif)"> {{notif.detail.a_f}}  </a> 支付失败！</span>
            </span>

            <!-- {{notif.detail.f_n}} -->
          </div>
        </li>
      </ul>
      <div class="read_more">
        <a href="javascript:;" @click="$router.push({path: '/news'})">全部消息</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {createRandom} from '@/common/js/createRandom';

export default {
  name: 'Notice',
  data() {
    return {
      /*消息类型(与后端字段一致)*/
      isFrist: true,
      unReadNum: 0,  //消息未读数
      chatUnreadNum: 0, //私信未读数
      recentNotifs: [],
      nType: {
        auth_edit: 'auth_edit',
        auth_view: 'auth_view',
        user_follow: 'user_follow',
        post_comment: 'post_comment',
        comment_comment: 'comment_comment',
        post_upvote: 'post_upvote',
        keep_comment: 'keep_comment',
        keep_add: 'keep_add',
        keep_update: 'keep_update',
        flow_comment: 'flow_comment',
        coactor: 'coactor',
        visitor: 'visitor',
        contact: 'contact',
        admin_auth: 'admin_auth',   // 律师认证审核消息通知
        enterprise_audit: 'enterprise_audit', // 企业开通审核消息通知'
        order_audit: 'order_audit',  // 银行转账支付确认消息通知
        enterprise_audit_change: 'enterprise_audit_change',  // 企业信息变更审核消息通知
        enterprise_audit_change_admin: 'enterprise_audit_change_admin',  // 企业管理员变更审核消息通知
        schedure_add: 'schedure_add',
        lawyer_designate: 'lawyer_designate',
        join_team: 'join_team',
        case_comment: 'case_comment',  // 没接收的业务案件
        case_create: 'case_create',
        expire_remind: 'expire_remind',
        user_evaluate: 'user_evaluate',
        flow_caseRecord: 'flow_caseRecord',
        flow_push: 'flow_push',
        flow_auth_edit: 'flow_auth_edit',
        file_push: 'file_push',
        dissolve_team: 'dissolve_team',
        quit_team: 'quit_team',
        kickout_team: 'kickout_team',
        client_coactor: 'client_coactor',

        // 2018.7.27 新增通知
        company_admin: 'company_admin',
        normal_create_case: 'normal_create_case',
        lawyer_create_company_case: 'lawyer_create_company_case',
        normal_del_case: 'normal_del_case',
        normal_create_flow: 'normal_create_flow',
        normal_del_flow: 'normal_del_flow',
        service_expire: 'service_expire',
        service_affirm: 'service_affirm',
        choose_lawyer: 'choose_lawyer',
        replaced_lawyer: 'replaced_lawyer',
        renew_choose_lawyer: 'renew_choose_lawyer',
        company_create_case: 'company_create_case',
        refuse_service_affirm: 'refuse_service_affirm',
        agree_service_affirm: 'agree_service_affirm',
        company_normal: 'company_normal',
        company_normal_del: 'company_normal_del',

        // 2018.12.25 新增通知
        latent_com_push: 'latent_com_push', // 将潜在企业客户第一次推送给律师时通知
        latent_com_change: 'latent_com_change', // 潜在企业客户更换律师时给被更换律师通知
        add_honsen_role: 'add_honsen_role', // 将用户添加到弘商角色中
        del_honsen_role: 'del_honsen_role', // 将用户从弘商角色中剔除
        add_company_salesman: 'add_company_salesman', // 对潜在企业客户授权业务员时通知
        del_company_salesman: 'del_company_salesman', // 对潜在企业客户删除业务员时通知
        add_serve_lawyer: 'add_serve_lawyer', // 添加服务律师给律师通知
        del_serve_lawyer: 'del_serve_lawyer', // 删除服务律师给律师通知
        company_account_dredge: 'company_account_dredge', // 选择企业联系人时给添加的人通知
        company_account_remove: 'company_account_remove', // 选择企业联系人时给被删除的人通知

        // 2019.02.22
        customer_coactor: 'customer_coactor', // 添加客户协作者时通知
        // 2019.03.26 新增 客户列表添加外访者
        customer_visitor: 'customer_visitor',
        // 2019.04.10 新增律师客户管理模块通知消息
        add_lawyerClient_cooperation: 'add_lawyerClient_cooperation',
        del_lawyerClient_cooperation: 'del_lawyerClient_cooperation',
        // 2019.06.26 咨询模块，律师加入会话
        invite_lawyer: 'invite_lawyer',
        //2020,8,31 台账劳动合同到期提示
        standing_book:'standing_book',
        //2020,9,24 取消编辑权限
        cancel_auth_editor:'cancel_auth_editor',
        //2020,9,24 取消阅读权限
        cancel_auth_viewer:'cancel_auth_viewer',
        //2020,11,11 企业客户合同到期提示
        customers_sign_date:'customers_sign_date',
        //2020.12.8退休提示
        employee_retire:'employee_retire',
        //2021.1.8种子用户消息提示
        set_seeds_user:'set_seeds_user',
        //2021.3.9法律专栏付费成功通知
        law_article_pay_success:'law_article_pay_success',
        //2021.3.9法律专栏付费失败通知
        law_article_pay_fail:'law_article_pay_fail'
      },
      consultReadNum:0,  //咨询消息数
    }
  },
  computed: {
    isLawyer() {
      return this.$store.state.mineInfo.is_lawyer;
    },
    isCompany(){
      return this.$store.state.mineInfo.have_company;
    },
    currentNotif() {
      return this.$store.state.notifData;
    },
    loginStatus() {
      return this.$store.state.loginStatus;
    },
    // 是否为弘商管家
    honsenOffice() {
      if (this.loginStatus && this.$store.state.mineInfo.honsen_office_clerk.length) {
        if (this.$store.state.mineInfo.honsen_office_clerk[0] === 1) {
          return true
        } else {
          return false
        }

      } else {
        return false
      }
    },
    consultChat() {
        return this.$store.state.consultChat;
    },
    consultNum(){
      return this.$store.state.consultNum;
    },
    singlechat() {
        return this.$store.state.singlechat;
    },
  },
  beforeMount() {
    if(this.loginStatus){
      this.getUnreadNum();
      this.getChatUnreadNum();
      this.getConsultUnReadNum();
    }
  },
  methods: {
    //跳转续费
    gotoOrderMange(){
      this.$gotoLawyer('orderManagement');
    },
    //律师加入咨询会话，并跳转页面
    toLawyerChat(item){
      let url='consultcenter/lawyerjoin';
      let params = {
          client_id:item.detail.a
      }
      this.$ajax('post' , url , params, res => {
          if (res.retcode === 0) {
              this.$message({
                  type: 'success',
                  message: '成功!'
              });
              let details = this.$router.resolve({
                name: "lawyerChat",
                // query: {
                //   customerId:item.detail.a,
                //   customerName:item.detail.a_n
                // }
              });
              window.open(details.href, "_blank")
          } else {
            this.$message.error(res.data.errmsg)
          }
      })
    },
    toConfirm() {
      if( this.$store.getters.auth_code_3 == 1 ){
        this.$message.success('你的账号已经认证!')
      }else{
        // this.$router.push({name: 'identitySet'});
        this.$gotoLawyer('identitySet');
      }
    },
    toCompany() {
      // this.$goto({name: 'legalCenter'});
    },
    //挑战到台账
    goStandBook(){
      this.$gotoCompany('contractManage');
    },
    toCompanyService() {
      // this.$goto({name: 'legalService'});
    },
    enterNews() {
      if(this.isFrist){
        this.getRecentNotifs();
      }
    },
    toPersonalCenter(id) {
      if( !id ){
        return false;
      }
      this.$router.push({name: 'personalCenter', params: {id: id}})
    },
    toPostDetail(id) {
      this.$router.push({name: 'post', params: {post_id: parseInt(id)}});
    },
    toBusinessList(id) {
      // this.$goto({ name: 'businessList', query: { personalcaseid: id}});
      // this.$gotov1('/business/?personalcaseid=' + id);
    },
    toSelectLawyer(id) {
      // this.$router.push({ name: 'selectLawyer', params: { id: id}});
      // this.$gotov1('/personalPage/selectLawyer/' + id);
    },
    toCaseEdit(id, flowid) {
      console.log(123)
      if (this.isCompany) {
        this.$gotoCompany('caseEdit/' + id);
      } else {
        this.$ajax('get', `biz/case/info/${id}`, (data) => {
          // 成功再跳转(在该案件页面下时，url不变时加随机数强制改变url)
          if (flowid) {
            // this.$router.push({name: 'caseEdit', params: {caseid: id}, query: {from: flowid + '_' +createRandom()}});
            this.$gotoLawyer('caseEdit/' + id + '?from=' + flowid + '_' + createRandom());
          }else {
            // this.$router.push({name: 'caseEdit', params: {caseid: id}});
            this.$gotoLawyer('caseEdit/' + id);
          }
        });
      }
    },
    //跳转商事法律专栏详情页
    toLawArticle(item){
      this.$router.push({name: 'lawColumnInfo', params: {law_id: parseInt(item.detail.a)}});
    },
    readAll() {
      if(!this.unReadNum){
        return;
      }

      this.$ajax('post', 'notification/read', (data) => {
        this.getRecentNotifs();
        // this.getUnreadNum();
        // this.unReadNum = 0;
        // this.recentNotifs.forEach((val) => {
        //   val.is_readed = 1;
        // });
      });
    },
    //消息未读数
    getUnreadNum() {
      this.$ajax('get', 'notification/unreadnum', (data) => {
        this.unReadNum = data.num;
      });
    },
    //私信未读数
    getChatUnreadNum() {
        this.$ajax('get', '/chat/unreadnum', (data) => {
            this.chatUnreadNum = data.unread_num;
        });
    },
    //咨询消息未读数
    getConsultUnReadNum(){
      this.$ajax('get', 'consultcenter/getUnreadMsgNum', (data) => {
        this.consultReadNum = Number(data.data);
      })
    },
    getRecentNotifs() {
      let num = this.unReadNum > 8 ? this.unReadNum : 8;
      // let num = 4;

      this.$ajax('get', `notification/recent?take=${num}`, data => {
        // 去掉不需要的通知
        let arr = data.data.filter(val => this.notifType(val.type));

        arr.forEach(e => {
          if( e.type == 'service_affirm' && typeof e.detail.f_n == 'number' ){
            this.$ajax('get', `/userinfo/detail/${e.detail.f_n}`, (data2) => {
              e.detail.f_n = data2.data.name;
            });
          }
        });

        this.recentNotifs = arr;
        // console.log(this.recentNotifs, '执行了')
        this.isFrist = false;
      });
    },
    logout() {
      // 先关闭socket
      if(window.socket){
        window.socket.close();
      }
      this.$ajax('post', 'logout', (data) => {
        // 重置状态
        this.$store.commit('clearalldata');

        this.$message.success('退出登录成功！');
        this.$router.push({name: 'home'});
      });
    },
    notifType(type) {
      return type != 'user_feedback' && type != 'steward_feedbackReply' && type != 'logout';
    },

    customerDetails(type,item) {
	  if(type == 1){
		  this.$gotoLawyer(`customerDetails/${item.detail.a}`)
	  }else{
		  this.$gotoLawyer(`customerDetails/${item.detail.ctmid}`)
	  }
    },
    goAdminList(lcid) {
      // this.$router.push({path:'/admin/list', query: {lcid}})
    },
    goAdminLawyer(lawid) {
      // this.$router.push({path: '/admin/lawyerData', query: {lawid}})
    },
    gotoChat() {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      this.$store.commit('setSide', 'chat');
      this.chatUnreadNum = 0;
    },
    //跳转咨询
    gotoHonsenChat() {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      if(this.$store.state.mineInfo.is_lawyer){
        // 律师跳转咨询页
        let details = this.$router.resolve({
          name: "lawyerChat",
          query: {
            
          }
        });
        window.open(details.href, "_blank")
      }else if(this.$store.state.mineInfo.isSupportStaff){
        //客服跳转咨询管理页，
        let details = this.$router.resolve({
            name: "consultSession",
            query: {
              
            }
          });
        window.open(details.href, "_blank")
      }else if(this.honsenOffice){
        //管理员跳转咨询管理页，
        let details = this.$router.resolve({
            name: "customerRecord",
            query: {
              
            }
          });
        window.open(details.href, "_blank")
      }else{
        //用户跳转咨询页
        let details = this.$router.resolve({
          name: "chats",
          query: {
            visitUrl:window.location.href
          }
        });
        window.open(details.href, "_blank")
      }
    },
  },
  watch: {
    loginStatus:{
      deep:true,
      handler(newval,oldval){
        if(newval){
          this.getUnreadNum();
          this.getChatUnreadNum();
        }
      }
    },
    consultChat:{
      deep: true,
      handler: function(v, ov){

      }
    },
    consultNum:{
      deep:true,
      handler:function(v,on){
        this.consultReadNum = Number(v.msgNum);
      }
    },
    singlechat: {   // 获取到的一条信息
        deep: true,
        handler: function(v, ov){
            if( v.type == 'text' ){
                this.chatUnreadNum += 1;
            }
        }
    },
    currentNotif: {
      deep: true,
      handler(newval, oldval) {
        let val = JSON.parse(JSON.stringify(newval));

        if(val.type == 'unread_msg_num'){
          this.unReadNum = Number(val.detail.num);
          return false;
        }

        if( val.type == 'logout' ){
          this.logout();
          return false;
        }

        // 反馈 或 退出登录
        if (!this.notifType(val.type)) {
          return false;
        }

        if(val.type == 'upgrate_honsen'){
          this.$alert(val.detail.content, '更新提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }else{
          val.is_readed = 0;
          this.recentNotifs.unshift(val);
          this.unReadNum += 1;
        }

        

        /* 认证审核结果通知 */
        if(val.type == 'admin_auth'){
          if (val.detail.result) {
            this.$alert(val.detail.reason, '认证审核', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                // console.log(`action: ${ action }`);
              }
            });
          } else {
            this.$alert(`${val.detail.reason}，现在去重新认证？`, '认证审核', {
              confirmButtonText: '确定',
              type: 'error',
              showCancelButton: true,
              callback: action => {
                if( action == 'confirm' ){
                  this.$gotoLawyer('identitySet');
                }
              }
            });
          }

          /* 改变状态码 */
          let auth_code_str = this.$store.state.mineInfo.auth_code.toString();
          /* 审核通过状态码第四位变为1,审核失败状态码第四位变为2 */
          let _num = val.detail.result? '1': '2';
          let auth_code_value = auth_code_str.substring(0,3) + _num + auth_code_str.substring(4);
          this.$store.commit('changeMineInfo', {auth_code: Number(auth_code_value)});
        }
      }
    },
  },
  filters: {
    getDate(time) {
      return moment(time).format('YYYY/MM/DD');
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/notice/index.vue